import { render, staticRenderFns } from "./PlayerSoundCloud.vue?vue&type=template&id=5a3163e0&scoped=true&"
import script from "./PlayerSoundCloud.vue?vue&type=script&lang=js&"
export * from "./PlayerSoundCloud.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSoundCloud.vue?vue&type=style&index=0&id=5a3163e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3163e0",
  null
  
)

export default component.exports